export default "__VITE_ASSET__CcQKU7UA__"